<!--
 * @Author: ghy
 * @Date: 2023-07-26 14:20:42
 * @LastEditors: ghy
 * @LastEditTime: 2023-10-08 10:23:19
 * @Description: 仪器样例详情
-->
<template>
  <div class="equipDetails" v-loading="loadingFlag">
    <cus-title text="仪器样例"></cus-title>
    <div class="equipDetails-content">
      <div class="content-left">
        <div class="left-title">
          {{ detailsObj.coverTitle }}
        </div>
        <p>适用学段：{{ detailsObj.sectionNames }}</p>
        <p>适用学科：{{ detailsObj.subjectNames }}</p>
        <p>仪器使用参考属性：{{ detailsObj.useNames }}</p>
        <div class="carousel-box">
          <el-carousel
            trigger="click"
            height="300px"
            ref="carousel"
            :autoplay="false"
          >
            <el-carousel-item v-if="videoImageUrl">
              <video
                width="450px"
                height="300px"
                style="object-fit: fill"
                v-if="videoUrl != ''"
                :src="videoUrl"
                :controls="true"
                controlslist="nodownload"
              >
                您的浏览器不支持视频播放
              </video>
            </el-carousel-item>
            <el-carousel-item v-for="(item, index) in imageBox" :key="index">
              <img :src="item.src" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="left-imgbox">
          <div class="video-image-box" @mouseenter="changeIndex(0)" v-if="videoImageUrl">
            <img :src="videoImageUrl" alt="" />
            <div class="el-icon-video-play"></div>
          </div>
          <div
            v-for="(item, index) in imageBox"
            :key="index"
            @mouseenter="changeIndex(index + 1)"
          >
            <img :src="item.src" alt="" />
          </div>
        </div>
      </div>
      <div class="content-right" >
        <pdf
          v-for="item in pageTotal"
          :src="pdfUrl"
          :key="item"
          :page="item"
          @page-loaded="pageLoaded"
        ></pdf>
      </div>
    </div>
  </div>
</template>

<script>
import { findEquipDetail } from "@/api/equip";
import { getFileById } from "@/api/common";
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },

  data() {
    return {
      keyId: "",
      detailsObj: {},
      imageFileIdList: [],
      videoUrl: "",
      pdfUrl: "",
      imageBox: [],
      videoImageUrl: "",
      pageTotal: "",
      pageLoadNum: 0,
      loadingFlag: true,
    };
  },
  mounted() {
    this.keyId = this.$route.query.keyId;
    this.findEquipDetail();
  },
  methods: {
    closepdf() {
      this.isshowpdf = false;
    },
    pdferr(errurl) {
      console.log(errurl);
    },
    openpdf() {
      this.isshowpdf = true;
    },
    async findEquipDetail() {
      const res = await findEquipDetail({ keyId: this.keyId });
      this.detailsObj = res.data.detail;
      this.imageFileIdList = this.detailsObj.images.map((v) => v.fileId);
      console.log(this.imageFileIdList);
      //1:封面图;2:配图;31:视频封面图;32:视频文件 4:Pdf
      
      if (this.detailsObj && this.detailsObj.videoFileId) {
        this.getFileById(this.detailsObj.videoFileId, 32);
      }
      if (this.detailsObj && this.detailsObj.videoCoverFileId) {
        this.getFileById(this.detailsObj.videoCoverFileId, 31);
      }
      if (this.detailsObj && this.detailsObj.detailFileId) {
        this.getFileById(this.detailsObj.detailFileId, 4);
      }
      this.imageFileIdList.forEach((v) => {
        this.getFileById(v, 2);
      });
    },
    async getFileById(item, fileFlag) {
      console.log(fileFlag);
      const res = await getFileById({
        fileId: item,
        moduleFlag: "equip",
        downFlag:0
      });
      if (fileFlag === 32) {
        this.videoUrl =
          "data:video/mp4;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      }else if ([1, 2, 31].includes(fileFlag)) {
        const src =
          "data:image/png;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
        if (fileFlag == 2) {
          this.imageBox.push({
            src: src,
          });
        } else if (fileFlag == 31) {
          this.videoImageUrl = src;
        }
      }  else if (fileFlag === 4) {
        const src =
          "data:application/pdf;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
        this.pdfUrl = pdf.createLoadingTask(src, { withCredentials: false });
        this.pdfUrl.promise
          .then((pdf) => (this.pageTotal = pdf.numPages))
          .catch((error) => {
            this.loadingFlag = false;
            console.log(error);
          });
      }
    },
    changeIndex(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    pageLoaded() {
      this.pageLoadNum++;
      if (this.pageLoadNum == this.pageTotal) {
        this.loadingFlag = false;
        console.log(this.pageLoadNum, this.pageTotal, "pageLoaded");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.equipDetails {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  .equipDetails-content {
    display: flex;
    justify-content: space-between;
  }
  .content-left {
    > p {
      margin-top: 5px;
      color: #333;
    }
  }
  .content-right {
    width: 540px;
    height: 650px;
    overflow-y: scroll;
    margin-top: 20px;
    .iframe-class {
      width: 100%;
      height: 100%;
      background: #fff;
    }
  }
  .left-title {
    font-size: 21px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #020202;
    line-height: 21px;
    margin: 20px 0;
  }
  .carousel-box {
    width: 450px;
    border: 1px solid #999;
    margin-top: 20px;
  }
  .left-imgbox {
    display: flex;
    width: 450px;
    flex-wrap: wrap;
    padding: 10px 10px 0 10px;
    box-sizing: border-box;
    margin-top: 10px;
    background: rgba(0, 0, 0, 0.05);
    > div {
      width: 77px;
      height: 51px;
      margin-right: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
    .video-image-box {
      position: relative;
      > div {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
        color: #e6e6e6;
        background: #555;
        border-radius: 50%;
      }
    }
  }
}
.priview-pdf-img {
  img {
    width: 100px;
    height: 100px;
  }
}
& /deep/ .el-dialog {
  width: 80%;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/equip/equipDetails.vue